import { Route, Routes, useNavigate } from "react-router-dom"

import { PrivateRoute, PublicRoute } from "./lib/conditionalRouter"
import Style from "./style"

import Login from "./ui/Login"
import Mantain from "./ui/Maintenance"
import SelectEvent from "./ui/SelectEvent"
import Timer from "./ui/Timer"

import InternalServerError from "./ui/InternalServerError"
import Maintenance from "./ui/Maintenance"
import NotFound from "./ui/NotFound"
import { useEffect, useState } from "react"
import useLoginCookie from "shared/model/useLoginCookie"
import useRoleCookie from "shared/model/useRoleCookie"

const Router = () => {
    const [isMaintenance, setIsMaintenance] = useState(process.env.REACT_APP_MAINTENANCE === "true")
    const [, , deleteLoginCookie] = useLoginCookie()
    const [, , deleteRoleCookie] = useRoleCookie()
    const navigate = useNavigate()
   
    useEffect(() => {
      if(isMaintenance) {
        deleteLoginCookie()
        deleteRoleCookie()
        navigate("/")
      }
    }, [])

    return (
        <Style.Main>
            <Routes>

                {isMaintenance ? (
                    <Route path="/" element={<Maintenance setIsMaintenance={setIsMaintenance} />} />
                ) : (
                  <>
                      {/* 비로그인 */}
                <Route element={<PublicRoute />}>
                    <Route path="/" element={<Login />} />
                </Route>

                {/* 로그인 */}
                <Route element={<PrivateRoute />}>
                    <Route path="/select" element={<SelectEvent />} />
                    <Route path="/event/:idx/timer" element={<Timer />} />
                </Route>

                {/* 상관 없음 */}
                <Route path="/maintenance" element={<Mantain />} />
                <Route path="/500" element={<InternalServerError />} />
                <Route path="*" element={<NotFound />} />
                  </>
                )}

                

            

            </Routes>
        </Style.Main>
    )
}

export default Router